const SmallTypes = {
	"TV-EPISODE": 1,
	ALBUM: 1,
	"PODCAST-EPISODE": 1,
	PODCAST: 1,
	"VIDEO-GAME": 1
};
export default SmallTypes;
